import React from "react";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import MSWManagementSecondaryCollectionStore from "./store/MSWManagementSecondaryCollectionStore";
import { formattedDate } from "../../../../Common/helper/helpar";

export const MSWDeployedVehiclesInnerExport = ({ fromDate, toDate, selectedDate }) => {
  const { MSWDepolyedData } = MSWManagementSecondaryCollectionStore();

  const data = MSWDepolyedData || [];

  const formatDateTime = (date = new Date()) => {
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
  };

  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
  };

  /* ================= EXCEL ================= */
  const downloadAsExcel = async () => {
    if (!data.length) {
      alert("No data available to export.");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Deployed Vehicles data");

    const boldFont = { bold: true };
    const currentDateTime = formatDateTime();

    // Row 1 - Report Generated On
    worksheet.addRow([`Report Generated On: ${currentDateTime}`]);
    worksheet.mergeCells(1, 1, 1, 7);
    worksheet.getCell(1, 1).font = boldFont;
    worksheet.getCell(1, 1).alignment = { horizontal: "center" };

    // Row 2 - Report Title with filter dates
    worksheet.addRow([
      `Deployed Vehicles Data Report on ${formattedDate(selectedDate)} `,
    ]);
    worksheet.mergeCells(2, 1, 2, 7);
    worksheet.getCell(2, 1).font = boldFont;
    worksheet.getCell(2, 1).alignment = { horizontal: "center" };

    worksheet.addRow([]); // empty row for spacing

    // Header row with background color
    const headerRow = worksheet.addRow([
      "S.No",
      "Zone Name",
      "Circle Name",
      "Ward",
      "Vehicle Type",
      "Owner Type",
      "Vehicle Capacity",
      "Vehicle Number",
      "Scanned Date",
      "Latitude",
      "Longitude",
      "Depolyed By",
      "Shift",
    ]);

    headerRow.eachCell((cell) => {
      cell.font = boldFont;
      cell.alignment = {
        horizontal: "center",
        wrapText: true,
        vertical: "middle",
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" },
      }; // light red/pink
    });

    // Data rows
    let serial = 1;
    data.forEach((row) => {
      const dataRow = worksheet.addRow([
         serial++,
        row.zoneName ?? "",
        row.circleName ?? "",
        row.wardName ?? "",
        row.vehicleTypeName ?? "",
        row.ownerTypeName ?? "",
        row.vehicleCapacityName ?? "",
        row.vehicleNumber ?? "",
        formattedDate(row.deploymentDate) ?? "",
        row.scannedLatitude ?? "",
        row.scannedLongitude ?? "",
        row.deployedBy ?? "",
        row.shiftName ?? "",
      ]);

        dataRow.eachCell((cell) => {
          cell.alignment = { horizontal: "center" };
         
        });
    });

    worksheet.columns = Array(7).fill({ width: 20 });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Vehicle_Deployment_Report.xlsx";
    link.click();
  };

  /* ================= PDF ================= */
  const downloadAsPDF = () => {
    if (!data.length) {
      alert("No data available to export.");
      return;
    }

    const doc = new jsPDF("l", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const currentDateTime = formatDateTime();

    // Row 1 - Report Generated On
    doc.setFontSize(12);
    doc.text(`Report Generated On: ${currentDateTime}`, pageWidth / 2, 10, {
      align: "center",
    });

    // Row 2 - Title with filter dates
    doc.setFontSize(14);
    doc.text(
      `Detailed Vehicle Deployment Data Report on ${formattedDate(selectedDate)}`,
      pageWidth / 2,
      18,
      { align: "center" },
    );

    let serial = 1;
    const tableRows = data.map((row) => {
      return [
         serial++,
        row.zoneName ?? "",
        row.circleName ?? "",
        row.wardName ?? "",
        row.vehicleTypeName ?? "",
        row.ownerTypeName ?? "",
        row.vehicleCapacityName ?? "",
        row.vehicleNumber ?? "",
        formattedDate(row.deploymentDate) ?? "",
        row.scannedLatitude ?? "",
        row.scannedLongitude ?? "",
        row.deployedBy ?? "",
        row.shiftName ?? "",
      ];
    });

    autoTable(doc, {
      startY: 26,
      head: [
        [
          "S.No",
          "Zone Name",
          "Circle Name",
          "Ward",
          "Vehicle Type",
          "Owner Type",
          "Vehicle Capacity",
          "Vehicle Number",
          "Scanned Date",
          "Latitude",
          "Longitude",
          "Depolyed By",
          "Shift",
        ],
      ],
      body: tableRows,
      theme: "grid",
      headStyles: {
        fillColor: [0, 102, 204],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
      styles: { halign: "center", fontSize: 9 },
      didParseCell: function (data) {
        if (data.row.raw[1] === "Total") {
          data.cell.styles.fontStyle = "bold";
        }
      },
    });

    doc.save("Vehicle_Deployment_Report.pdf");
  };

  return (
    <>
      <button className="btn btn-excel me-2" onClick={downloadAsPDF}>
        <i className="fa-solid fa-file-pdf me-1"></i> PDF
      </button>

      <button className="btn btn-excel" onClick={downloadAsExcel}>
        <i className="fa-solid fa-file-excel me-1"></i> Excel
      </button>
    </>
  );
};
